const global = {
  //api -url
  serverUrl: process.env.REACT_APP_API_URL
};

export default global;